import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { EMPTY } from 'rxjs';
import { take, map, switchMap, catchError, finalize } from 'rxjs/operators';
import { PackDetailsModalComponent } from 'src/app/___COMPONENTS/pack-details-modal/pack-details-modal.component';
import { ApiConnectorService } from 'src/app/___LOGIC/__api/api-connector.service';
import { DependencyService } from 'src/app/___LOGIC/__common/dependency.service';
import { FunctionsService } from 'src/app/___LOGIC/__common/functions.service';
import { ResolverService } from 'src/app/___LOGIC/__common/resolver.service';
import { GuiFlowService } from 'src/app/___LOGIC/__gui/gui-flow.service';
import { NavigationService } from 'src/app/___LOGIC/__nav/navigation.service';
import { BudgetsResolverService } from 'src/app/___LOGIC/resolvers/budgets.resolver';

@Component({
  selector: 'app-package-builder',
  templateUrl: './package-builder.component.html',
  styleUrls: ['./package-builder.component.css']
})
export class PackageBuilderComponent implements OnInit {

  packages = [];
  loadedPackages = [];
  showHowTo = false;
  showProductsList = false;
  
  products = [];
  panelOpenState = [];
  packageTypes = [
    {
      name: 'General',
      type: 'basic'
    },
    {
      name: 'Legal',
      type: 'basic'
    },
    {
      name: 'Tourism',
      type: 'basic'
    },
    {
      name: 'Basic',
      type: 'basic'
    },
    {
      name: 'Premium',
      type: 'premium'
    },
    {
      name: 'Full',
      type: 'full'
    }
  ];

  plans = [];

  clientId;
  config1;
  config2;

  dialogRef;
  showPacks = true;

  constructor(private commonFunctions: FunctionsService,private guiFlow: GuiFlowService,private apiConnector: ApiConnectorService,public dialog: MatDialog,private resolver: ResolverService, private route: ActivatedRoute, private budgetResolver: BudgetsResolverService,private dependenciesService: DependencyService,private navigationService: NavigationService) { }

  ngOnInit(): void {
    this.clientId = this.commonFunctions.getSelectedClientId();
    const data = this.route.snapshot.data['productList'];
    this.products = data.productList.data;
    this.loadedPackages = data.packageList.data;
    this.plans = data.planList.data;
    
    //this.getPlans();
    this.initCrud();
  }

    initCrud(){
    // REFACTOR : ojo que las funciones de create dependen de quien elija en el FK_1 y en el FK_2 a uno le pone el currentId al otro el insertado FK
    this.config1= {
      id: this.config1 && this.config1.id? this.config1.id : this.commonFunctions.generateRandomNumber(),
      tableName: 'plan',
      cacheLabel: 'plan'+ this.commonFunctions.getSelectedClientId(),
      tableProperties: [
        {
            "columnName": "id",
            "dataType": "int"
        },
        {
            "columnName": "name",
            "dataType": "varchar"
        },
        {
            "columnName": "description",
            "dataType": "text"
        },
        {
            "columnName": "total",
            "dataType": "float"
        },
        {
            "columnName": "paid",
            "dataType": "tinyint"
        },
        {
            "columnName": "FK_ID_clientDetails",
            "dataType": "int"
        }
    ],
      table1: '',
      table2: '',
      tableX: '',
      FK_1: '',
      FK_2: '',
      FK_1_value: null,
      FK_2_value: null,
      queryName: '',
      hiddenInputFields: [],
      mandatoryFields: [],
      currentId: this.commonFunctions.getSelectedClientId(),
      showCreateUpdateButtons: true
    };

    this.config2= {
      id: this.config2 && this.config2.id? this.config2.id : this.commonFunctions.generateRandomNumber(),
      tableName: 'packageXplan',
      cacheLabel: 'packageXplan'+ this.commonFunctions.getSelectedClientId(),
      tableProperties: [
        {
            "columnName": "FK_ID_package",
            "dataType": "int"
        },
        {
            "columnName": "FK_ID_plan",
            "dataType": "int"
        }
    ],
      table1: '',
      table2: '',
      tableX: '',
      FK_1: '',
      FK_2: '',
      FK_1_value: null,
      FK_2_value: null,
      queryName: '',
      hiddenInputFields: [],
      mandatoryFields: [],
      currentId: this.commonFunctions.getSelectedClientId(),
      showCreateUpdateButtons: true
    };
  }

  reload(){
    if(!this.commonFunctions.getSelectedClientId()){
      this.guiFlow.openSimpleSnackBar('No hay cliente seleccionado', 'warning');
    }else{
      
    }
  }

  reloadPlans(){
      this.getPlans();
  }

  reloadPacks(){
    this.resolver.getPacksAvailable(true);
  }

  isPacksLoading(){
    return this.resolver.isLoading('package');
  }

  switchHow(){
    this.showHowTo = !this.showHowTo;
  }

  switchProductList(){
    this.showProductsList = !this.showProductsList;
  }

  getPacksAvailable(){
    return this.packages;
  }

  newPackage(){
    let emptyPak = {
      category: null,
      package_id: null,
      package_type: null,
      name: null,
      description: null,
      price: null,
      currency: 'USD',
      products: []
    }
    this.panelOpenState.push(false);
    this.packages.push(emptyPak);
  }

  savePackage(pack,id){
    this.guiFlow.openLoadingModal();
    if(this.areFieldsFilled(id)){
      this.preparePackage(this.packages[id]);
      this.panelOpenState[id] = false;
      this.apiConnector.newDynamicApiRequest('post', 'package', this.preparePackage(this.packages[id]))
        .subscribe(
          (response) => {
            this.processFKCreate(response,id);
          },
          (error) => {
            this.guiFlow.reportError(error,'onboarding-page');
          }
        );
    }else{
      this.guiFlow.reportError('Faltan campos obligatorios','onboarding-page');
    }
  }

  areFieldsFilled(id){
    let resp = true;
    !this.packages[id].package_type? resp = false: null;
    !this.packages[id].price? resp = false: null;
    !this.packages[id].currency? resp = false: null;
    /* !resp? console.log('Missing fields') : null; */
    return resp;
  }

  removeProduct(product,pack){
    pack.products = this.commonFunctions.removeObjectWithId(pack.products, product.id);
  }

  preparePackage(p){
    
    let pack = {
      package_id: p.package_type+this.commonFunctions.generateRandomNumber4Digit(),
      package_type: p.package_type,
      name: p.package_type.toUpperCase(),
      description: p.description,
      category: '',
      price: p.price,
      currency: p.currency,
    }
    return pack;
  }

  processFKCreate(response: any,index){
    if(response.OK && response.OK.records && response.OK.records.id){
      this.guiFlow.openSimpleSnackBar('Success inserting package item ✅', null);
      this.insertFk_values(response.OK.records.id,index);
    }else{
      this.guiFlow.openSimpleSnackBar('Id of inserted element missing ⚠️', null);
    }
  }

  onTemplateSelect(template,pak){
    let arr;
    switch(template){
      case 'general':
        arr = ['31','32'];
        pak.products = this.getProductListByIds(arr);
        break;
      case 'legal':
        arr = ['40'];
        pak.products = this.getProductListByIds(arr);
        break;
      case 'tourism':
        arr = ['32','34','35','36'];
        pak.products = this.getProductListByIds(arr);
        break;
      case 'basic':
        arr = ['1','2','17','19','9' ];
        pak.products = this.getProductListByIds(arr);
        break;
      case 'premium':
        arr = ['4','3','15','10','11'];
        pak.products = this.getProductListByIds(arr);
        break;
      case 'full':
        arr = ['20','21','16'];
        pak.products = this.getProductListByIds(arr);
        break;
      default:
        break;
    }
  }

  onSelection(event){
    this.commonFunctions.setSelectedClientId(event.id);
    this.getPlans();
  }

  getPlans(){
    this.budgetResolver.resolve(this.commonFunctions.getSelectedClientId()).subscribe(data => {
      this.plans = data.planList.data;
    }, err => {
      console.error('Error loading data:', err);
    });

  }

  getProductListByIds(array){
    let res = [];
    for(let obj of array){
      this.getProductById(obj)? res.push(this.getProductById(obj)) : null;
    }
    return res;
  }

  getProductById(id){
    for(let p of this.products){
      if( p.id == id ){
        return p;
      } 
    }
    return null;
  }

  insertFk_values(lastInsertedId,index){
    let FK_Object = {
      FK_ID_product: null,
      FK_ID_package: null
    };
   
    FK_Object['FK_ID_package'] = lastInsertedId;

    for(let product of this.packages[index].products){
      FK_Object['FK_ID_product'] = product.id;
      this.apiConnector.newDynamicApiRequest('post', 'productXpackage', FK_Object)
      .subscribe(
        (response) => {
          this.guiFlow.openSimpleSnackBar('Success inserting FKs 🔑  ... (id)'+FK_Object[0], null);
          this.panelOpenState[index] = false;
          console.log('Success inserting FKs');
          window.scroll(0, 0);
          this.guiFlow.closeLoadingModal();
        },
        (error) => {
        }
      );
    }
  }

  onSelectProduct(event,pak){
    pak.products.push(event.value);
  }

  onSelectType(event,pak){
    pak.package_type = event.value.type;
  }

  onSelectCurrency(event,pak){
    pak.currency = event.value;
  }

  onSelectCategory(event,pak){
    pak.category = event.value;
  }

  openModal(pack: any) {
  let loading = true;
    this.dependenciesService
      .getBackendDataForQueryId('getPackDetails', String(pack.id))
      .pipe(
        take(1),
        // your API often wraps data in `data` and sometimes arrays
        map(resp => resp?.data ?? resp?.data ?? resp ?? null),
        switchMap((producList) => {
          if (!producList) { throw new Error('No data'); }

          // keep your original pattern...
          this.dialogRef = this.dialog.open(PackDetailsModalComponent, {
            width: '720px',
            data: { pack, producList },       // pass both pack and fetched details
            disableClose: false
          });

          // ...but return afterClosed() to keep the observable chain alive
          return this.dialogRef.afterClosed();
        }),
        catchError(err => {
          console.error(err);
          return EMPTY;
        }),
        finalize(() => loading = false)
      )
      .subscribe(dialogResult => {
        // execution continues AFTER modal is closed
        if (dialogResult) {
          // e.g. refresh your list
          // this.reloadList();
        }
      });
  }

  goBack(){
    this.navigationService.goBack();
  }


}